// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- MOBILE STYLES --- */

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: var(--spacing);
}

.contentTitle {
  color: var(--text-color);
  padding-bottom: 10px;
}

.contactInfo {
  font-size: 12px;
  color: var(--secondary-text-color);
  margin-bottom: var(--sm-spacing);
  margin-left: 10px;
}

.contentDescription {
  font-size: 15px;
}

.info {
  font-size: 15px;
}

.infoDescription {
  margin-bottom: var(--sm-spacing);
}

.personalContactInfo {
  display: flex;
  align-items: center;
}

ul {
  list-style: none;
}

.mediaWrap {
  border-left: 2px solid var(--grey);
  padding-left: var(--sm-spacing);
  padding-top: 12px;
  padding-bottom: 12px;
}

.formGroup {
  padding-right: 15px;
}

.formControl {
  font-size: 15px;
  width: 100%;
  padding: 10px 10px;
  border: none;
  background-color: #161616;
  margin-bottom: 20px;
  border-bottom: 1px solid var(--grey);
  border-radius: 1px;
  outline: transparent;
  color: var(--grey);
}

.formControl:focus {
  border-bottom: 1px solid var(--hl-color);
}

textarea {
  resize: none;
  height: auto;
  font-family: "Poppins", sans-serif;
}

.icon {
  color: var(--hl-color);
  font-size: 28px;
}

.infoIcon {
  width: var(--spacing);
  display: flex;
  align-items: center;
}

.infoType {
  color: var(--text-color);
  font-size: 15px;
}

.infoValue a {
  color: var(--hl-color);
}

.contactForm {
  margin-bottom: var(--sm-spacing);
}

.contact .socialIcons {
  display: none;
}

.mediaWrap a:hover {
  color: #03b979;
}

@media (min-width: 400px) {
  .contactInfo {
    font-size: 15px;
  }
}

@media (min-width: 750px) {
  .contact .socialIcons {
    display: inline;
    padding-bottom: var(--sm-spacing);
  }

  .contact .socialIcons::before,
  .contact .socialIcons::after {
    background-color: var(--grey);
    content: "";
    height: 2px;
    width: var(--spacing);
    display: inline-block;
    margin-bottom: 7px;
    margin-right: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/contact/contact.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAE1B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;IACf,iCAAiC;EACnC;;EAEA;;IAEE,6BAA6B;IAC7B,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB;EACpB;AACF","sourcesContent":["/* --- MOBILE STYLES --- */\n\n.contact {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: var(--spacing);\n}\n\n.contentTitle {\n  color: var(--text-color);\n  padding-bottom: 10px;\n}\n\n.contactInfo {\n  font-size: 12px;\n  color: var(--secondary-text-color);\n  margin-bottom: var(--sm-spacing);\n  margin-left: 10px;\n}\n\n.contentDescription {\n  font-size: 15px;\n}\n\n.info {\n  font-size: 15px;\n}\n\n.infoDescription {\n  margin-bottom: var(--sm-spacing);\n}\n\n.personalContactInfo {\n  display: flex;\n  align-items: center;\n}\n\nul {\n  list-style: none;\n}\n\n.mediaWrap {\n  border-left: 2px solid var(--grey);\n  padding-left: var(--sm-spacing);\n  padding-top: 12px;\n  padding-bottom: 12px;\n}\n\n.formGroup {\n  padding-right: 15px;\n}\n\n.formControl {\n  font-size: 15px;\n  width: 100%;\n  padding: 10px 10px;\n  border: none;\n  background-color: #161616;\n  margin-bottom: 20px;\n  border-bottom: 1px solid var(--grey);\n  border-radius: 1px;\n  outline: transparent;\n  color: var(--grey);\n}\n\n.formControl:focus {\n  border-bottom: 1px solid var(--hl-color);\n}\n\ntextarea {\n  resize: none;\n  height: auto;\n  font-family: \"Poppins\", sans-serif;\n}\n\n.icon {\n  color: var(--hl-color);\n  font-size: 28px;\n}\n\n.infoIcon {\n  width: var(--spacing);\n  display: flex;\n  align-items: center;\n}\n\n.infoType {\n  color: var(--text-color);\n  font-size: 15px;\n}\n\n.infoValue a {\n  color: var(--hl-color);\n}\n\n.contactForm {\n  margin-bottom: var(--sm-spacing);\n}\n\n.contact .socialIcons {\n  display: none;\n}\n\n.mediaWrap a:hover {\n  color: #03b979;\n}\n\n@media (min-width: 400px) {\n  .contactInfo {\n    font-size: 15px;\n  }\n}\n\n@media (min-width: 750px) {\n  .contact .socialIcons {\n    display: inline;\n    padding-bottom: var(--sm-spacing);\n  }\n\n  .contact .socialIcons::before,\n  .contact .socialIcons::after {\n    background-color: var(--grey);\n    content: \"\";\n    height: 2px;\n    width: var(--spacing);\n    display: inline-block;\n    margin-bottom: 7px;\n    margin-right: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
